import crud from '@/crud/form/form'

import data from './data'
import components from './components'
import methods from './methods'
import resources from '../../resources'
import computed from './computed'

export default {
  data,
  methods,
  components,
  computed,
  mixins: [crud, resources]
}



// WEBPACK FOOTER //
// ./src/app/professional/company/covenants/create/resources/index.js